/** @format */

/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import TableHeaderContentCell from '../../../../components/Table/TableHeaderContentCell';
import { roles, UserRoleHelper } from '../../../../helpers/UserRoleHelper';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import { pricelistSchemaElementConstants, pricelistsReducersType } from '../../../../modules/pricelists/reducers';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import AddButton from '../../../../components/Buttons/AddButton';
import PricelistSchemaElementInterface from '../../../../interfaces/billing/PricelistSchemaElementInterface';
import RemoveButton from '../../../../components/Buttons/RemoveButton';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import { ItemLoaders } from '../../../../core/loaders/ItemLoaders';
import { PricelistSchemasCollectionInterface } from '../../../../interfaces/api/PricelistSchemasCollectionInterface';
import Pager from '../../../../components/Adescom/Pager';
import { PricelistSchemaConnectorsCollectionInterface } from '../../../../interfaces/api/PricelistSchemaConnectorsCollectionInterface';
import Order from '../../../../interfaces/forms/Order';
import Filter from '../../../../interfaces/forms/Filter';
import { PricelistSchemaElementsCollectionInterface } from '../../../../interfaces/api/PricelistSchemaElementsCollectionInterface';
import oplAppStyle from '../../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';
import { GeneralHelper } from '../../../../helpers/GeneralHelper';
import FakePagination from '../../../../components/Pagination/FakePagination';

interface PricelistAssignmentProps {
    classes: any;
    setPricelistSchemaElement: (pricelistSchemaElements: Array<PricelistSchemaElementInterface>) => void;
    pricelistSchemaElements: Array<PricelistSchemaElementInterface>;
    pricelistSchemaElementsFullResponse: PricelistSchemaConnectorsCollectionInterface | null;
    loadPricelistElements: (pricelistId: number | null, uri?: string) => void;
    activePricelistSchema: number | null;
}

const PricelistAssignment = (props: PricelistAssignmentProps): React.ReactElement => {
    const dispatch = useDispatch();
    const tableStickyHeader = { root: props.classes.tableStickyHeader };
    const tableCellRoot = { root: props.classes.tableCellRoot };
    const tableStickyCommand = { root: props.classes.tableStickyCommand };
    const PRICELIST_SCHEMA_ELEMENT_URI = '/pricelist_schema_elements';
    const PRICELIST_SCHEMA_CONNECTOR_URI = '/pricelist_schema_connectors';
    const { listOnDetail } = useSelector((state: { pricelistSchemaElementsReducers: pricelistsReducersType }) => {
        return state.pricelistSchemaElementsReducers;
    });

    const [afterFirstTimeFill, setAfterFirstTimeFill] = useState<boolean>(false);
    const [orders, setOrders] = useState<Array<Order>>([]);
    const [filters, setFilters] = useState<Array<Filter>>([]);
    const [assignmentPricelistSchemaElementFilters, setAssignmentPricelistSchemaElementFilters] = useState<Array<Filter>>([]);
    const [assignmentPricelistSchemaElementOrders, setAssignmentPricelistSchemaElementOrders] = useState<Array<Order>>([
        { name: 'mainname', value: 'asc' },
    ]);
    const [filteredPricelistSchemas, setFilteredPricelistSchemas] = useState<Array<PricelistSchemaElementInterface>>(props.pricelistSchemaElements);

    const addPricelistSchemaElement = (param: { pricelistElement: PricelistSchemaElementInterface }): void => {
        if (
            !props.pricelistSchemaElements.some((pe: PricelistSchemaElementInterface) => {
                return pe.id === param.pricelistElement.id;
            })
        ) {
            let newArr = [...props.pricelistSchemaElements, param.pricelistElement];
            props.setPricelistSchemaElement(newArr);
        }
    };

    const removePricelistSchemaElement = (param: { pricelistElement: PricelistSchemaElementInterface }): void => {
        let newArr = [...props.pricelistSchemaElements];
        props.pricelistSchemaElements.forEach((el: PricelistSchemaElementInterface, indx: number) => {
            if (el.id === param.pricelistElement.id) {
                newArr.splice(indx, 1);
            }
        });
        props.setPricelistSchemaElement(newArr);
    };

    const paginationCallbackFunctionForPricelistNotAssignment = (uri?: string): void => {
        if (!uri) {
            uri = FormGeneralHelper.getPath(PRICELIST_SCHEMA_ELEMENT_URI);
        }
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(uri),
            pricelistSchemaElementConstants.LIST_ON_DETAIL,
            filters,
            orders.length > 0 ? orders : [{ name: 'mainname', value: 'asc' }],
            (data: PricelistSchemasCollectionInterface) => {},
            {
                propagateDataToCallback: false,
                dispatchAfterCallback: true,
            }
        );
    };
    // const paginationCallbackFunctionForPricelistAssignment = (uri?: string): void => {
    //     if (!uri) {
    //         uri = FormGeneralHelper.getPath(PRICELIST_SCHEMA_CONNECTOR_URI);
    //     }
    //     props.loadPricelistElements(props.activePricelistSchema, uri);
    // };

    const loadPricelistSchemaElementList = useCallback(
        (uri?: string) => {
            if (!uri) {
                uri = FormGeneralHelper.getPath(PRICELIST_SCHEMA_ELEMENT_URI);
            }
            const itemLoaders = new ItemLoaders(dispatch);
            itemLoaders.getListWithCallback(
                FormGeneralHelper.getByUri(uri),
                pricelistSchemaElementConstants.LIST_ON_DETAIL,
                [...filters, { name: 'deleted', value: false }],
                orders.length > 0 ? orders : [{ name: 'mainname', value: 'asc' }],
                () => {},
                {
                    propagateDataToCallback: false,
                    dispatchAfterCallback: true,
                }
            );
        },
        [filters, orders, dispatch]
    );

    const updateOrderList = (orders: Array<Order>): void => {
        setOrders(orders);
    };
    const updateFilterList = (filters: Array<Filter>): void => {
        setFilters(filters);
    };

    const handleSetAssignmentPricelistSchemaElementOrders = (orders: Array<Order>): void => {
        setAssignmentPricelistSchemaElementOrders(orders);
        setFilteredPricelistSchemas(
            filteredPricelistSchemas.sort((a, b) =>
                GeneralHelper.sort(a, b, orders[0].name, orders.length > 0 && typeof orders[0].value === 'string' ? orders[0].value : 'asc')
            )
        );
    };
    const handleSetAssignmentPricelistSchemaElementFilters = (filters: Array<Filter>): void => {
        setAssignmentPricelistSchemaElementFilters(filters);
    };

    const filterAssignedPricelists = useCallback(() => {
        if (assignmentPricelistSchemaElementFilters.length > 0) {
            const x = props.pricelistSchemaElements.filter((value: PricelistSchemaElementInterface) => {
                const isOkArr: Array<boolean> = [];

                assignmentPricelistSchemaElementFilters.forEach((el: any) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                    //@ts-ignore
                    if (value[el.name].toLowerCase().includes(el.value.toLowerCase())) {
                        isOkArr.push(true);
                    } else {
                        isOkArr.push(false);
                    }
                });
                return !isOkArr.includes(false);
            });
            setFilteredPricelistSchemas(x);
        } else {
            setFilteredPricelistSchemas(props.pricelistSchemaElements);
        }
    }, [assignmentPricelistSchemaElementFilters, props.pricelistSchemaElements]);

    useEffect(() => {
        loadPricelistSchemaElementList();
    }, [loadPricelistSchemaElementList]);

    useEffect(() => {
        if (props.pricelistSchemaElements && props.pricelistSchemaElements.length > 0 && !afterFirstTimeFill) {
            setFilteredPricelistSchemas(props.pricelistSchemaElements);
            setAfterFirstTimeFill(true);
        }
    }, [props.pricelistSchemaElements, filteredPricelistSchemas, afterFirstTimeFill]);

    useEffect(() => {
        let timer = setTimeout(filterAssignedPricelists, 500);
        return (): void => {
            clearTimeout(timer);
        };
    }, [assignmentPricelistSchemaElementFilters, filterAssignedPricelists]);

    return (
        <GridContainer>
            <GridItem xs={6}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell classes={tableStickyCommand} align="left">
                                <TableHeaderContentCell textAlign="left" title="clients:c.commands" />
                            </TableCell>
                            <TableCell classes={tableStickyCommand} align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="pricelists:h.name"
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    fieldName="mainname"
                                    showSort={true}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyCommand} align="left">
                                <TableHeaderContentCell textAlign="left" title="pricelists:h.vat_amount" showSort={false} />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listOnDetail &&
                            listOnDetail['hydra:member'].map((el: PricelistSchemaElementInterface) => {
                                return (
                                    <TableRow key={el.id}>
                                        <TableCell classes={tableStickyHeader} align="left">
                                            {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_PUT) && (
                                                <AddButton
                                                    tooltipTitle="pricelists:button.assign_pricelist"
                                                    callback={addPricelistSchemaElement}
                                                    callbackParam={{ pricelistElement: el }}
                                                    disabled={props.pricelistSchemaElements.some((pe: PricelistSchemaElementInterface) => {
                                                        return pe.id === el.id;
                                                    })}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} align="left">
                                            {el.mainname}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} align="left">
                                            {el.vat}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell classes={tableCellRoot} colSpan={4}>
                                {listOnDetail && listOnDetail['hydra:view'] && (
                                    <Pager callback={paginationCallbackFunctionForPricelistNotAssignment} views={listOnDetail['hydra:view']} />
                                )}
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </GridItem>
            <GridItem xs={6}>
                <div>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell classes={tableStickyCommand} align="left">
                                    <TableHeaderContentCell textAlign="left" title="clients:c.commands" />
                                </TableCell>
                                <TableCell classes={tableStickyCommand} align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="pricelists:h.name"
                                        updateOrderList={handleSetAssignmentPricelistSchemaElementOrders}
                                        updateFilterList={handleSetAssignmentPricelistSchemaElementFilters}
                                        fieldName="mainname"
                                        showSort={true}
                                        defaultDirection="asc"
                                        searchFieldType="string"
                                        filters={assignmentPricelistSchemaElementFilters}
                                        sort={assignmentPricelistSchemaElementOrders}
                                    />
                                </TableCell>
                                <TableCell classes={tableStickyCommand} align="left">
                                    <TableHeaderContentCell
                                        textAlign="left"
                                        title="pricelists:h.vat_amount"
                                        updateOrderList={handleSetAssignmentPricelistSchemaElementOrders}
                                        updateFilterList={handleSetAssignmentPricelistSchemaElementFilters}
                                        fieldName="vat"
                                        showSort={true}
                                        defaultDirection="asc"
                                        searchFieldType="string"
                                        filters={assignmentPricelistSchemaElementFilters}
                                        sort={assignmentPricelistSchemaElementOrders}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <FakePagination>
                                {filteredPricelistSchemas.map((el: PricelistSchemaElementInterface) => {
                                    return (
                                        <TableRow key={el.id}>
                                            <TableCell classes={tableStickyHeader} align="left">
                                                {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_TARIFF_PUT) && (
                                                    <RemoveButton
                                                        tooltipTitle="pricelists:button.remove_assigned_pricelist"
                                                        callback={removePricelistSchemaElement}
                                                        callbackParam={{ pricelistElement: el }}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} align="left">
                                                {el.mainname}
                                            </TableCell>
                                            <TableCell classes={tableCellRoot} align="left">
                                                {el.vat}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </FakePagination>
                        </TableBody>
                    </Table>
                </div>
            </GridItem>
        </GridContainer>
    );
};

export default withStyles(oplAppStyle)(PricelistAssignment);
